/* AVOLT business guidance. Informational only: never changes cart or taxes. */
(() => {
  if (customElements.get('avolt-business-info')) return;
  customElements.define('avolt-business-info', class extends HTMLElement {
    connectedCallback() {
      if (this.bound || !window.HTMLDialogElement?.prototype.showModal) return;
      const details = this.querySelector(':scope > details');
      const trigger = details?.querySelector('summary');
      const content = details?.querySelector('.avolt-business__content');
      if (!trigger || !content) return;
      this.bound = true;
      const dialog = document.createElement('dialog');
      dialog.className = 'avolt-business__dialog';
      dialog.setAttribute('aria-label', content.querySelector('h3').textContent);
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'avolt-business__close';
      close.textContent = '×';
      close.setAttribute('aria-label', this.dataset.closeLabel);
      close.addEventListener('click', () => dialog.close());
      dialog.append(close, content);
      this.append(dialog);
      // Escape closes this dialog without dismissing the surrounding cart drawer.
      let closingWithEscape = false;
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && dialog.open) {
          closingWithEscape = true;
          event.stopPropagation();
        }
      });
      this.addEventListener('keyup', event => {
        if (event.key === 'Escape' && closingWithEscape) {
          closingWithEscape = false;
          event.stopPropagation();
        }
      });
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', event => {
        event.preventDefault();
        dialog.showModal();
        trigger.setAttribute('aria-expanded', 'true');
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
        if (trigger.isConnected) trigger.focus({ preventScroll: true });
      });
    }
  });
})();
